export default "__VITE_ASSET__D07LqNzU__"